import React, { useEffect, useMemo } from "react";
import { Button, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";

import "../../../layouts/styles.css";
import useStyles from "./PaymentFailedPageStyles";
import { getSafeSameOriginReturnPathFromSearch } from "../../../utils/safeReturnTo";
import { trackPaymentFailedPageView } from "../../../analytics/canonicalTracking";

const SUPPORT_MAIL = "mailto:support@sugarcribs.com";

const PaymentFailedPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const safeReturnPath = useMemo(() => {
    if (typeof window === "undefined") {
      return null;
    }
    return getSafeSameOriginReturnPathFromSearch(
      location.search,
      window.location.origin
    );
  }, [location.search]);

  useEffect(() => {
    trackPaymentFailedPageView({
      has_return_to: Boolean(safeReturnPath),
    });
  }, [safeReturnPath]);

  const handleHome = () => {
    history.push("/");
  };

  return (
    <div className="container">
      <Helmet>
        <title>Payment failed | Sugar Cribs</title>
        <meta
          name="description"
          content="Your payment could not be completed. Check your card, limits, or bank authentication (3D Secure) and try again when you are ready."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="main-content">
        <div className={classes.root}>
          <Typography component="h1" className={classes.title}>
            Payment failed
          </Typography>
          <Typography component="p" className={classes.body}>
            We could not complete this transaction; your card may not have been
            charged. Check your card details, spending limits, and any bank
            verification step (such as 3D Secure), then try again from where you
            left off.
          </Typography>
          <div className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              className={classes.primaryButton}
              aria-label="Go to homepage"
              onClick={handleHome}
            >
              Go to homepage
            </Button>
          </div>
          <a
            href={SUPPORT_MAIL}
            className={classes.supportLink}
            aria-label="Email Sugar Cribs support"
          >
            Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedPage;
